import 'angular';
import '../file-browser/right_panel.html';

angular.module('GorillaBoy.directives')
.directive('fileBrowserRightPanel', () => {
    return {
        restrict: 'E',
        controller: 'FilesRightPanelController',
        templateUrl: './file-browser/right_panel.html'
    }
});